function initImageReveals() {
	const reveals = document.querySelectorAll(".image-reveal");
	if (!reveals.length) return;

	reveals.forEach((reveal) => {
		const frame = reveal.querySelector(".image-reveal__frame");
		const overlay = reveal.querySelector(".image-reveal__img--overlay");
		if (!frame || !overlay) return;

		let isVertical = null;
		const startPercentage = clamp(parseFloat(reveal.dataset.start), 0, 100) / 100 || 0.5;

		const handle = document.createElement("div");
		handle.className = "image-reveal__handle";
		handle.setAttribute("role", "slider");
		handle.setAttribute("tabindex", "0");
		handle.setAttribute("aria-valuemin", "0");
		handle.setAttribute("aria-valuemax", "100");
		const chevrons =
			"<svg viewBox='0 0 12 20' width='10' height='16' fill='none' aria-hidden='true'>" +
			"<path d='M1 7 6 2l5 5' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/>" +
			"<path d='M1 13l5 5 5-5' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/>" +
			"</svg>";
		handle.innerHTML = "<span class='image-reveal__grip'>" + chevrons + "</span>";
		frame.appendChild(handle);

		let dragging = false;
		let percentage = startPercentage;

		function clamp(val, min, max) {
			return Math.max(min, Math.min(val, max));
		}

		function setPosition(p) {
			percentage = clamp(p, 0, 1);
			const inset = isVertical
				? `${percentage * 100}% 0 0 0`
				: `0 0 0 ${percentage * 100}%`;
			overlay.style.clipPath = `inset(${inset})`;
			overlay.style.webkitClipPath = `inset(${inset})`;
			if (isVertical) {
				handle.style.top = percentage * 100 + "%";
				handle.style.left = "";
			} else {
				handle.style.left = percentage * 100 + "%";
				handle.style.top = "";
			}
			handle.setAttribute("aria-valuenow", Math.round(percentage * 100));
		}

		function getPositionFromEvent(e) {
			const rect = frame.getBoundingClientRect();
			const clientX = e.touches && e.touches[0] ? e.touches[0].clientX : e.clientX;
			const clientY = e.touches && e.touches[0] ? e.touches[0].clientY : e.clientY;
			return isVertical
				? (clientY - rect.top) / rect.height
				: (clientX - rect.left) / rect.width;
		}

		function onDown(e) {
			e.preventDefault();
			dragging = true;
			document.addEventListener("mousemove", onMove);
			document.addEventListener("touchmove", onMove, { passive: false });
		}

		function onUp() {
			dragging = false;
			document.removeEventListener("mousemove", onMove);
			document.removeEventListener("touchmove", onMove);
		}

		function onMove(e) {
			if (!dragging) return;
			e.preventDefault();
			setPosition(getPositionFromEvent(e));
		}

		function onKeydown(e) {
			const step = 0.05;
			if (isVertical && e.key === "ArrowUp") setPosition(percentage - step);
			else if (isVertical && e.key === "ArrowDown") setPosition(percentage + step);
			else if (!isVertical && e.key === "ArrowLeft") setPosition(percentage - step);
			else if (!isVertical && e.key === "ArrowRight") setPosition(percentage + step);
			else return;
			e.preventDefault();
		}

		function syncOrientation() {
			const axis = getComputedStyle(handle).getPropertyValue("--image-reveal-axis").trim();
			const vertical = axis === "y";
			if (vertical === isVertical) return;

			isVertical = vertical;
			handle.setAttribute("aria-orientation", isVertical ? "vertical" : "horizontal");
			setPosition(percentage);
		}

		syncOrientation();
		window.addEventListener("resize", syncOrientation);

		handle.addEventListener("mousedown", onDown);
		document.addEventListener("mouseup", onUp);
		handle.addEventListener("touchstart", onDown, { passive: false });
		document.addEventListener("touchend", onUp);
		handle.addEventListener("keydown", onKeydown);
	});
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", initImageReveals);
} else {
	initImageReveals();
}
